/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Or_Shoot_Share_ConnInputs */

const en_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace | Shoot Share Connect`)
};

const es_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mercado | Shoot Share Connect`)
};

const fr_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace | Shoot Share Connect`)
};

const de_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz | Shoot Share Connect`)
};

const ja_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーケットプレイス | Shoot Share Connect`)
};

const zh_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场 | Shoot Share Connect`)
};

const ar_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السوق | Shoot Share Connect`)
};

const id_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace | Shoot Share Connect`)
};

const it_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace | Shoot Share Connect`)
};

const ru_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркетплейс | Shoot Share Connect`)
};

const pt_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace | Shoot Share Connect`)
};

const ko_marketplace_or_shoot_share_conn = /** @type {(inputs: Marketplace_Or_Shoot_Share_ConnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마켓플레이스 | Shoot Share Connect`)
};

/**
* | output |
* | --- |
* | "Marketplace \| Shoot Share Connect" |
*
* @param {Marketplace_Or_Shoot_Share_ConnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const marketplace_or_shoot_share_conn = /** @type {((inputs?: Marketplace_Or_Shoot_Share_ConnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Or_Shoot_Share_ConnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketplace_or_shoot_share_conn(inputs)
	if (locale === "es") return es_marketplace_or_shoot_share_conn(inputs)
	if (locale === "fr") return fr_marketplace_or_shoot_share_conn(inputs)
	if (locale === "de") return de_marketplace_or_shoot_share_conn(inputs)
	if (locale === "ja") return ja_marketplace_or_shoot_share_conn(inputs)
	if (locale === "zh") return zh_marketplace_or_shoot_share_conn(inputs)
	if (locale === "ar") return ar_marketplace_or_shoot_share_conn(inputs)
	if (locale === "id") return id_marketplace_or_shoot_share_conn(inputs)
	if (locale === "it") return it_marketplace_or_shoot_share_conn(inputs)
	if (locale === "ru") return ru_marketplace_or_shoot_share_conn(inputs)
	if (locale === "pt") return pt_marketplace_or_shoot_share_conn(inputs)
	return ko_marketplace_or_shoot_share_conn(inputs)
});